import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  Component,
  DestroyRef,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { InputFieldComponent } from '../../../../ui/inputField/inputField.component';
import { FormWrapperComponent } from '../../../../ui/form-wrapper/form-wrapper.component';
import { ModalComponent } from '../../../../ui/modal-component/modal-component.component';
import {
  EngagementMessage,
  EngagementMessageSchedule,
} from '../../../../../pages/organization/campaigns/types/messagesTypes';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { CampaignsService } from '../../../../../services/campaign/campaigns-api.service';
import { CampaignDetails } from '../../../../../pages/organization/campaigns/types/campaignDetails';
import { CustomizableButtonComponent } from '../../../../ui/customizable-button/customizable-button.component';
import { TimeZoneService } from '../../../../../services/timezone/time-zone.service';

@Component({
  selector: 'app-edit-schedule',
  standalone: true,
  imports: [
    CommonModule,
    InputFieldComponent,
    FormWrapperComponent,
    ModalComponent,
    ReactiveFormsModule,
    CustomizableButtonComponent,
  ],
  templateUrl: './edit-schedule.component.html',
  styleUrl: '../../campaign-form.css',
})
export class EditScheduleComponent implements OnInit {
  @Output() onClose = new EventEmitter();
  @Input({ required: true }) openModal = false;
  @Input() scheduleData!: EngagementMessageSchedule;
  @Input() messageSchedules!: EngagementMessageSchedule[];
  @Input() messageId!: number;
  campaignsService = inject(CampaignsService);
  private destroyRef = inject(DestroyRef);
  timeZoneService = inject(TimeZoneService);
  campaign!: CampaignDetails;

  get getTimeZones() {
    return this.timeZoneService.getTimeZones();
  }

  constructor(private fb: FormBuilder) {}

  scheduleForm = this.fb.group({
    scheduleDate: ['', Validators.required],
    scheduleTime: ['', Validators.required],
    scheduleTimeZone: ['', Validators.required],
  });

  submitted = false;

  get scheduleDate() {
    return this.scheduleForm.get('scheduleDate');
  }

  get scheduleTime() {
    return this.scheduleForm.get('scheduleTime');
  }

  get scheduleTimeZone() {
    return this.scheduleForm.get('scheduleTimeZone');
  }

  validateMessageDate() {
    if (this.scheduleDate?.value) {
      const startDate = new Date(this.campaign.startDate!);
      const endDate = new Date(this.campaign.endDate!);
      const inputDate = new Date(this.scheduleDate?.value);
      if (startDate <= inputDate && inputDate <= endDate) {
        this.scheduleDate?.setErrors(null);
      } else {
        this.scheduleDate?.setErrors({ outOfRange: true });
      }
    }
    // console.log(this.scheduleDate?.value);
  }

  // very long thing to modify
  handleSubmit() {
    this.submitted = true;
    if (this.scheduleForm.invalid) return;

    // get edited schedule values
    const editedSchedule = {
      ...this.scheduleData,
      scheduleDate: this.scheduleDate?.value,
      scheduleTime: this.scheduleTime?.value,
      scheduleTimeZone: this.scheduleTimeZone?.value,
    };

    // filter out edited schedule and get unmodified schedules
    const unmodifiedSchedules = this.messageSchedules.filter(
      (item) => item.id !== this.scheduleData.id
    );

    // find message that has it's shedules changed
    const messageData = this.campaign.engagementMessages.find(
      (item) => item.id === this.messageId
    );

    const data = {
      ...this.campaign,
      engagementMessages: [
        ...this.campaign.engagementMessages.filter(
          (item) => item.id !== this.messageId
        ),

        // replace message with edited message
        {
          ...messageData,
          engagementMessageSchedules: [
            ...unmodifiedSchedules.map((item) => {
              return {
                id: item.id,
                engagementMessages: item.engagementMessages,
                scheduleDate: item.scheduleDate,
                scheduleTime: item.scheduleTime,
                scheduleTimeZone: item.scheduleTimeZone,
              };
            }),
            editedSchedule,
          ],
        },
      ],
    };


    // calling the edit api on this
    this.campaignsService
      .editCampaign(this.campaign.id, data, false)
      .subscribe(() => {
        this.onClose.emit();
      });
  }

  ngOnInit() {
    if (this.scheduleData) {
      this.scheduleForm.patchValue({
        scheduleDate: this.scheduleData?.scheduleDate,
        scheduleTime: this.scheduleData?.scheduleTime,
        scheduleTimeZone: this.scheduleData?.scheduleTimeZone,
      });
    }

    //assign data to component campaign variable
    this.campaignsService.campaignDetails
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
      this.campaign = data as CampaignDetails;
    });
  }
}
